import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

/**
 *
 * Simple component to display a tooltip when the text is truncated
 *
 */
interface SEllipsisTooltipProps {
  /**
   * Text to display
   */
  content: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SEllipsisTooltip',
  props: {
  content: null
},
  setup(__props) {


let tooltipDisabled = _ref(true);

/**
 * Activate tooltip if text is truncated
 * @param e
 */
const addTooltip = (e: MouseEvent) => {
  const el = e.target as HTMLElement;
  if (el.offsetWidth < el.scrollWidth) tooltipDisabled.value = false;
};

/**
 * Deactivate tooltip
 */
const removeTooltip = () => {
  tooltipDisabled.value = true;
};


return { __sfc: true,tooltipDisabled, addTooltip, removeTooltip, _ref }
}

})